export function DoorRoomReducer(state = [], action) {
    switch (action.type) {
        case "GET_DOOR_ROOMS":
            return action.payload.result;
        case "ADD_DOOR_TO_LIST":
            return [];
        default:
            return state;
    }
}

export function DoorModelReducer(state = [], action) {
    switch (action.type) {
        case "GET_DOOR_MODELS":
            return action.payload.result;
        case "ADD_DOOR_TO_LIST":
            return [];
        default:
            return state;
    }
}

export function DoorTypeReducer(state = [], action) {
    switch (action.type) {
        case "GET_DOOR_TYPES":
            return action.payload.result;
        case "ADD_DOOR_TO_LIST":
            return [];
        default:
            return state;
    }
}

export function DoorStyleReducer(state = [], action) {
    switch (action.type) {
        case "GET_DOOR_STYLES":
            return action.payload.result;
        case "ADD_DOOR_TO_LIST":
            return [];
        default:
            return state;
    }
}

export function DoorOptionReducer(state = { glass: [], extras: [], colours: [] }, action) {
    let colours = [];
    switch (action.type) {
        case "GET_DOOR_OPTIONS":
            colours = action.payload.result.colours;
            return {
                // Make sure the relatedColourId is 0 if the colour isn't available.
                colours: colours.map((colour) => ({...colour, relatedColourId: colours.map(({ id }) => id).includes(colour.relatedColourId) ? colour.relatedColourId : 0})),
                extras: action.payload.result.extras,
                glass: action.payload.result.glass
            };
        case "ADD_DOOR_TO_LIST":
            return { glass: [], extras: [], colours: [] };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/door_reducers.js